import {HttpClient} from '@angular/common/http';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {DcpBundleTemplate, JsonService, LocalStorageService, TransactionListCta, TransactionType} from '@dcp/configurator';
import {OccEndpointsService, Product, UserIdService} from '@spartacus/core';
import {Observable} from 'rxjs';
import {concatMap} from 'rxjs/operators';
import {LeadFormModel} from '../cta-form/lead-form/lead-form.model';

export interface LeadFormLastOpened {
  transactionListCta: TransactionListCta;
  transactionType: TransactionType;
}


export interface LeadFormDialogData {
  transactionListCta: TransactionListCta;
  transactionType: TransactionType;
  product: Product;
  bundleTemplate: DcpBundleTemplate;
  formName: string;
}


@Injectable({
  providedIn: 'root',
})
export class LeadService {

  static OPEN_LEAD_FORM_ON_INIT = 'openLeadFormOnInit';

  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private localStorageService: LocalStorageService,
    private jsonService: JsonService,
    @Inject(PLATFORM_ID) public platformId: object,
    protected userIdService: UserIdService
  ) {
  }

  /**
   * Sets a value that indicates if the nodal popup should be opened on page init.
   */
  get leadFormLastOpened(): LeadFormLastOpened {
    const transactionType: LeadFormLastOpened = this.jsonService.parseSafely(
      this.localStorageService.getItem(LeadService.OPEN_LEAD_FORM_ON_INIT)
    );
    this.leadFormLastOpened = undefined;
    return transactionType;
  }

  /**
   * Gets a value that indicates if the nodal popup should be opened on page init.
   *
   * @param formLastOpened transaction type to open the modal for.
   */
  set leadFormLastOpened(formLastOpened: LeadFormLastOpened) {
    this.localStorageService.setItem(LeadService.OPEN_LEAD_FORM_ON_INIT, JSON.stringify(formLastOpened));
  }

  /**
   * posts a new lead to the server.
   *
   * @param lead LeadFormModel containing the data of the form.
   */
  public postLeadData(lead: LeadFormModel): Observable<string> {
    return this.userIdService.getUserId().pipe(
      concatMap(userId => this.postLeadDataCallback(userId, lead))
    );
  }

  /**
   * Callback function that actually posts the data after a oAuth token has been received for the user.
   *
   * @param userId to add to the request
   * @param data LeadFormModel sent to the server by the post request
   */
  public postLeadDataCallback(userId: string, data: {}): Observable<string> {
    return this.http.post(
      this.occEndpointsService.buildUrl('/users/' + userId + '/leads'),
      data,
      {responseType: 'text'}
    );
  }
}
